import type React from 'react';
import { FormField, FormHelp, Label, Textarea } from '@zillow/constellation-10';

import type { Section } from '../../../models/index';
import YesAndNoExpansion from '../../Widgets/YesAndNoExpansion';
import { DEFICIENCIES_AND_CITATIONS } from '../../../constants/index';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function DeficienciesAndCitations({ section, setSectionValues }: Props): JSX.Element {
  function onNoDeficienciesAndCitations(): void {
    setSectionValues({
      [DEFICIENCIES_AND_CITATIONS.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesDeficienciesAndCitations(): void {
    setSectionValues({
      [DEFICIENCIES_AND_CITATIONS.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  function onDescriptionChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [DEFICIENCIES_AND_CITATIONS.FIELD_NAME.DESCRIPTION]: value,
    });
  }

  const deficienciesAndCitationsEnabled = section.getFieldValue(DEFICIENCIES_AND_CITATIONS.FIELD_NAME.IS_ENABLED);
  const deficienciesAndCitationsDescription = section.getFieldValue(DEFICIENCIES_AND_CITATIONS.FIELD_NAME.DESCRIPTION);

  return (
    <FormField
      required
      label={<Label>Have you received any notices of deficiencies or citations within the last 24 months?</Label>}
      description={
        <FormHelp>
          Deficiencies or citations related to health and sanitation, nuisances, and property maintenance are to be
          included
        </FormHelp>
      }
      control={
        <YesAndNoExpansion
          yesHandler={onYesDeficienciesAndCitations}
          noHandler={onNoDeficienciesAndCitations}
          yesActive={deficienciesAndCitationsEnabled}
        >
          <FormField
            required
            label={<Label>Describe these deficiencies or citations</Label>}
            control={
              <Textarea
                css={{ resize: 'vertical' }}
                value={deficienciesAndCitationsDescription}
                onChange={onDescriptionChange}
              />
            }
          />
        </YesAndNoExpansion>
      }
    />
  );
}
